<app-obra-social-form
  [editar]="editar"
  [obraSocial]="obraSocial"
></app-obra-social-form>
